<template>
    <div class="container-filter pb16">        
        <div class="btn-category-common">
            <div class="wrap-btn-category">
                <div class="gradiant-btn-category"></div>
                <div class="box-btn-category">
                    <button
                        class="btn-category"
                        :class="{'active' : isActive(item.ec_idx)}"
                        v-for="(item, index) in eventCategoryList"
                        :key="`categoryFilter${index}`"
                        @click="setFilterCategory(item.ec_idx)"
                    >{{ item.ec_name }}</button>
                </div>
            </div>
        </div>
        <div class="pl16 pr16 pt21 pb5 box-flex">
            <button class="box-flex mr-a" @click="showFilterModal">
                <div class="icon-filter-event"></div>
                <div class="text-filter-event">{{ $t('filter') }}</div>
            </button>
            <button class="box-flex" @click="showSortModal">
                <div class="text-filter-event pr4">
                    {{returnSortName()}}                    
                </div>
                <div class="button-sort-event"></div>
            </button>
        </div>
    </div>
</template>


<script>
import eventUtil from "@/components/event/eventUtil";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

const { filterConfig } = eventUtil;
export default {
    name: "EventFilterCategoryLayout",
    mixins: [],
    inject: ["setFilter", "setMultiFilter", "setSort"],
    components: {},
    props: {
        filterData: {
            default: () => {
                return {};
            },
        },
        eventCategoryList: {
            default: () => {
                return [];
            },
        },
        sortData: {},
    },
    data() {
        return {
            searchInput: "",
            filterCategory: [],
            filterStartPrice: "",
            filterEndPrice: "",
            usest: [],
            sellst: [],
        };
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {
        EventBus.$on("setEventFilterModal", this.setEventFilterModal);
        if (!util.isEmpty(this.$route.query.key)) {
            this.setFilterCategory(Number(this.$route.query.key));
        }

        EventBus.$on("setSortModal", this.setSortModal);
    },
    beforeUnmount() {
        EventBus.$off("setEventFilterModal");
        EventBus.$off("setSortModal");
    },
    unmounted() {},
    computed: {},
    methods: {
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setFilterCategory(key) {
            if (!this.filterCategory.includes(key)) {
                this.filterCategory.push(key);
            } else {
                this.filterCategory = this.filterCategory.filter(
                    (el) => el !== key
                );
            }
            this.setFilterFunc("eca", this.filterCategory);
        },
        setEventFilterModal(key) {
            this.usest = key.usest;
            this.sellst = key.sellst;

            let params = {
                eperArr: key.usest,
                nperArr: key.sellst,
            };
            this.setMultiFilter(params);
        },
        isActive(key) {
            return this.filterCategory.includes(key);
        },
        showFilterModal() {
            let data = {
                usest: this.usest,
                sellst: this.sellst,
            };

            this.$modal.show("event-normal-filter-modal", { filterData: data });
        },

        setSortModal(data) {
            console.log("123121323123123213213212");

            this.setSort(data.obt, data.obs);
        },

        showSortModal() {
            this.$modal.show("non-button-update-sort-modal",{sortData:this.sortData});
        },

        returnSortName() {
            switch (this.sortData.key) {
                case "e.updated_at":
                    return this.$t("b_update");
                case "e.e_start_date":
                    return this.$t("sort_event_closed");
                case "u.u_publish_total":
                    return this.$t("sort_event_lot");
                default:
                    return this.$t("b_update");
            }
        },
    },
    watch: {},
};
</script>
